import { createAction } from "@reduxjs/toolkit";

export const SET_LAST_LANDING_SLUG = createAction(
  "navigation/last-landing-slug/set"
);
export const CLEAR_LAST_LANDING_SLUG = createAction(
  "navigation/last-landing-slug/clear"
);
